import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { FlyoutSection } from 'containers';
import { ButtonBar } from 'components';
import { LLCheckbox } from 'components/FormElements';
import { setMessageCenterFilters } from 'redux/modules/messageCenter';
import styles from './FilterPanel.scss';
var FilterPanel = (_dec = connect(function (state) {
  return {
    theme: state.theme,
    socialAccounts: state.organization.current.SocialAccounts,
    filters: state.messageCenter && state.messageCenter.filters ? state.messageCenter.filters : []
  };
}, {
  setMessageCenterFilters: setMessageCenterFilters
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(FilterPanel, _Component);

  var _super = _createSuper(FilterPanel);

  function FilterPanel() {
    var _this;

    _classCallCheck(this, FilterPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderFilters", function () {
      var saFilters = _this.props.filters ? _this.props.filters : _this.socialNetworkFilters();
      return saFilters.map(function (filter, idx) {
        return /*#__PURE__*/React.createElement("span", {
          key: idx
        }, /*#__PURE__*/React.createElement(LLCheckbox, {
          label: /*#__PURE__*/React.createElement("span", {
            className: styles.filterLabel
          }, filter.icon ? filter.icon() : null, " ", filter.name),
          style: {
            marginLeft: '15px'
          },
          checked: filter.selected,
          onChange: function onChange() {
            return _this.toggleFilter(filter.id);
          }
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFilter", function (filterId) {
      var newFilterState = _this.props.filters.slice();

      var toggleFilter = newFilterState.find(function (filter) {
        return filter.id === filterId;
      });
      toggleFilter.selected = !toggleFilter.selected;

      _this.props.setMessageCenterFilters(newFilterState);
    });

    _defineProperty(_assertThisInitialized(_this), "socialNetworkFilters", function () {
      var fbFilters = _this.props.socialAccounts.some(function (sa) {
        return sa.platform.indexOf('Facebook') === 0;
      }) ? [{
        id: 0,
        name: 'Facebook Comments',
        icon: function icon() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              marginRight: 5
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-facebook-official"
          }));
        },
        selected: false,
        filterFunction: function filterFunction(conversation) {
          return true;
        } // eslint-disable-line

      }, {
        id: 1,
        name: 'Facebook Messages',
        icon: function icon() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              marginRight: 5
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-facebook-official"
          }));
        },
        selected: true,
        filterFunction: function filterFunction(conversation) {
          return true;
        } // eslint-disable-line

      }, {
        id: 2,
        name: 'Facebook Reviews',
        icon: function icon() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              marginRight: 5
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-facebook-official"
          }));
        },
        selected: false,
        filterFunction: function filterFunction(conversation) {
          return true;
        } // eslint-disable-line

      }] : [];
      var twFilters = _this.props.socialAccounts.some(function (sa) {
        return sa.platform === 'Twitter';
      }) ? [{
        id: 3,
        name: 'X (Twitter) @Mentions',
        icon: function icon() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              marginRight: 5
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-twitter-square"
          }));
        },
        selected: false,
        filterFunction: function filterFunction(conversation) {
          return true;
        } // eslint-disable-line

      }] : [];
      var igFilters = _this.props.socialAccounts.some(function (sa) {
        return sa.platform === 'Instagram';
      }) ? [{
        id: 4,
        name: 'Instagram Comments',
        icon: function icon() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              marginRight: 5
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-instagram"
          }));
        },
        selected: false,
        filterFunction: function filterFunction(conversation) {
          return true;
        } // eslint-disable-line

      }] : [];
      var liFilters = _this.props.socialAccounts.some(function (sa) {
        return sa.platform.indexOf('LinkedIn') === 0;
      }) ? [{
        id: 5,
        name: 'LinkedIn Messages',
        icon: function icon() {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              marginRight: 5
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-linkedin-square"
          }));
        },
        selected: false,
        filterFunction: function filterFunction(conversation) {
          return true;
        } // eslint-disable-line

      }] : [];
      return [].concat(fbFilters, twFilters, igFilters, liFilters);
    });

    return _this;
  }

  _createClass(FilterPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.setMessageCenterFilters(this.socialNetworkFilters());
    }
  }, {
    key: "render",
    value: function render() {
      var selectedDate = this.props.selectedDate ? moment(this.props.selectedDate) : null;
      var buttonItems = [{
        id: 1,
        selected: true,
        title: 'DATE'
      }, {
        id: 2,
        title: 'NETWORK'
      }];
      return /*#__PURE__*/React.createElement("div", {
        className: styles.filters
      }, /*#__PURE__*/React.createElement(FlyoutSection, {
        title: "SORT"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 10
        }
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        theme: this.props.theme,
        items: buttonItems
      }))), /*#__PURE__*/React.createElement(FlyoutSection, {
        title: "FILTER"
      }, this.renderFilters()));
    }
  }]);

  return FilterPanel;
}(Component), _defineProperty(_class2, "propTypes", {
  theme: PropTypes.object,
  filters: PropTypes.array,
  setMessageCenterFilters: PropTypes.func,
  socialAccounts: PropTypes.array
}), _defineProperty(_class2, "defaultProps", {}), _temp)) || _class);
export { FilterPanel as default };